/* tslint:disable */
/* eslint-disable */
/* @relayHash 355d970f29325e2b15ea9e5c0903b547 */

import { ConcreteRequest } from "relay-runtime";
export type ContactDealerInput = {
    buyerId: string;
    displayName?: string | null;
    itemPk?: string | null;
    sellerPk: string;
    messageContent: string;
    isOptIn?: boolean | null;
    action?: string | null;
    pageContext?: string | null;
    currencyConversionRateEventId?: string | null;
    clientMutationId?: string | null;
};
export type sendMessageMutationVariables = {
    input: ContactDealerInput;
};
export type sendMessageMutationResponse = {
    readonly contactDealer: {
        readonly conversation: {
            readonly id: string;
        } | null;
    } | null;
};
export type sendMessageMutation = {
    readonly response: sendMessageMutationResponse;
    readonly variables: sendMessageMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ContactDealerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contactDealer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContactDealerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "conversation",
        "storageKey": null,
        "args": null,
        "concreteType": "Conversation",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sendMessageMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "sendMessageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "sendMessageMutation",
    "id": "app-buyer-finding/292.0.0-2020-11-20T23:59:39.967Z/sendMessageMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '220832c976b0ad6213d8e667ff2ff6ff';
export default node;
